(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["happy-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('happy-reviews-carousel')) {
    class HappyReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        if (!this.track) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
        this.delay = (parseInt(this.dataset.delay, 10) || 4) * 1000;
        this.paused = false;
        this.timer = null;
        this.raf = null;

        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.updateActive();
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
        });

        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.track);

        if (this.autoplay) {
          const pause = () => { this.paused = true; };
          const resume = () => { this.paused = false; };
          this.addEventListener('mouseenter', pause);
          this.addEventListener('mouseleave', resume);
          this.addEventListener('focusin', pause);
          this.addEventListener('focusout', resume);
          this.addEventListener('touchstart', pause, { passive: true });
          this.addEventListener('touchend', () => setTimeout(resume, 2500), { passive: true });
          this.timer = setInterval(() => {
            if (!this.paused && !document.hidden) this.advance();
          }, this.delay);
        }
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      get step() {
        const slide = this.track.querySelector('.hrc__slide');
        if (!slide) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      get maxScroll() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      get maxIndex() {
        const step = this.step;
        if (!step || this.maxScroll <= 2) return 0;
        return Math.ceil((this.maxScroll - 2) / step);
      }

      get index() {
        const step = this.step;
        return step ? Math.min(Math.round(this.track.scrollLeft / step), this.maxIndex) : 0;
      }

      goTo(i) {
        const behavior = this.reduceMotion ? 'auto' : 'smooth';
        this.track.scrollTo({ left: i * this.step, behavior });
      }

      next() {
        this.index >= this.maxIndex ? this.goTo(0) : this.goTo(this.index + 1);
      }

      prev() {
        this.index <= 0 ? this.goTo(this.maxIndex) : this.goTo(this.index - 1);
      }

      advance() { this.next(); }

      build() {
        const scrollable = this.maxIndex > 0;
        if (this.prevBtn) this.prevBtn.hidden = !scrollable;
        if (this.nextBtn) this.nextBtn.hidden = !scrollable;

        if (this.dotsWrap) {
          const count = scrollable ? this.maxIndex + 1 : 0;
          this.dotsWrap.hidden = !scrollable;
          if (this.dotsWrap.children.length !== count) {
            this.dotsWrap.innerHTML = '';
            for (let i = 0; i < count; i++) {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'hrc__dot';
              dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
              dot.addEventListener('click', () => this.goTo(i));
              this.dotsWrap.appendChild(dot);
            }
          }
        }
        this.updateActive();
      }

      updateActive() {
        if (!this.dotsWrap) return;
        const active = this.index;
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('happy-reviews-carousel', HappyReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
